// @ts-nocheck
import * as React from "react";

const Mp4File: React.FC = () => {
    return (
        <svg viewBox="0 0 50 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.6536 26.1228V54.1917H48.1387V11.9509H36.3961V1.84766H8.6536V8.15725H6.81201V0H38.9902C42.6535 3.38084 46.3367 6.74201 50.0001 10.1032V56H34.9308H21.8813C16.8516 56 11.8417 56 6.81201 56V26.0835H8.6536V26.1228Z"
                fill="currentColor"
            />
            <path fillRule="evenodd" clipRule="evenodd" d="M0 9.57251H32.4554V24.747H0V9.57251Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.6437 40.0983H36.6734L33.7823 37.6216H30.7328L33.6437 40.0983ZM28.2774 40.0983H31.3071L28.416 37.6216H25.3863L28.2774 40.0983ZM23.2279 40.0983H26.2774L23.3665 37.6216H20.3368L23.2279 40.0983ZM20.0398 37.2678H37.9209V49.9263H20.0398V37.2678Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.0099 31.4299L24.1189 32.2947L28.6535 34.2997L31.5446 33.4151L27.0099 31.4299ZM32.1188 29.877L29.2277 30.7616L33.7624 32.7665L36.6733 31.882L32.1188 29.877ZM22.1585 32.8844L19.2674 33.7493L23.802 35.7542L26.7129 34.8697L22.1585 32.8844ZM35.9604 28.3439L18.8713 33.5134L20.0198 37.2677L37.1089 32.0982L35.9604 28.3242V28.3439Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.4752 14.3685V16.7665H17.4257C18.1979 16.7665 18.7326 16.6879 19.0494 16.5307C19.3663 16.3537 19.5247 16.0393 19.5247 15.5675C19.5247 15.0958 19.3861 14.8009 19.089 14.624C18.8118 14.4471 18.2178 14.3685 17.3069 14.3685H16.4752ZM25.0098 18.2604V15.3513L23.0494 18.2604H25.0098ZM25.0098 21.4053V19.7149H21.5247V18.28L25.2474 12.8943H26.6138V18.28H27.6633V19.7346H26.6138V21.425H25.0098V21.4053ZM14.7524 21.4053V12.9139H17.5049C18.4554 12.9139 19.1484 12.9533 19.6039 13.0515C20.0395 13.1302 20.4158 13.4053 20.7722 13.8181C21.1286 14.2702 21.3068 14.8206 21.3068 15.5282C21.3068 16.2358 21.1682 16.6486 20.891 17.0614C20.6138 17.4938 20.2573 17.769 19.8217 17.9459C19.3861 18.1031 18.6534 18.1818 17.6039 18.1818H16.495V21.3857H14.7722L14.7524 21.4053ZM4.79204 21.4053V12.9139H7.36629L8.91083 18.7125L10.4356 12.9139H13.0296V21.4053H11.4257V14.7223L9.74253 21.4053H8.05936L6.37619 14.7223V21.4053H4.77222H4.79204Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(Mp4File);
